// extracted by mini-css-extract-plugin
export default {"copyRightWrapper":"Copyright_copyRightWrapper__kj6Wp"};